import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import styled, { css } from 'styled-components';
import { ChevronDown } from '@olxbr/ds-icons';
import { Spinner } from '../Spinner';
export const LoadingIcon = styled(Spinner)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  ", "\n  pointer-events: none;\n"])), _ref => {
  let {
    variant
  } = _ref;
  return variant === 'medium' ? "right: 16px; top: 16px;" : "right: 10px; top: 6px;";
});
export const ChevronIcon = styled(ChevronDown)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  pointer-events: none;\n  ", "\n  color: ", ";\n"])), _ref2 => {
  let {
    variant
  } = _ref2;
  return variant === 'medium' ? "right: 16px; top: 12px;" : "right: 8px; top: 6px;";
}, _ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled ? 'var(--dropdown-icon-color-disabled)' : 'var(--dropdown-icon-color-base)';
});
export const SelectWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: ", ";\n"])), _ref4 => {
  let {
    variant
  } = _ref4;
  return variant == 'medium' ? '48px' : '28px';
});
const selectedStyle = _ref5 => {
  let {
    selected
  } = _ref5;
  if (!selected) return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: var(--dropdown-color-font-selected);\n    box-shadow: 0 0 0 var(--border-width-hairline) var(--dropdown-border-color-selected);\n  "])));
};
const errorStyle = _ref6 => {
  let {
    error
  } = _ref6;
  if (!error) return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    background-color: var(--dropdown-background-color-error);\n    box-shadow: 0 0 0 var(--border-width-hairline) var(--dropdown-border-color-error);\n  "])));
};
const LEFT_ICON_SIZES = {
  medium: '24px',
  small: '16px'
};
export const SelectNativeInput = styled.select(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: var(--font-family);\n  width: 100%;\n  height: 100%;\n  appearance: none;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  ", "\n\n  ", "\n\n  ", "\n  \n  \n  background-color: var(--dropdown-background-color-base);\n  color: var(--dropdown-color-font-base);\n  box-shadow: 0 0 0 var(--border-width-hairline) var(--dropdown-border-color-base);\n\n  ", "\n  ", "\n\n  option:not(:first-of-type) {\n    color: var(--dropdown-color-font-selected);\n  }\n\n  :hover {\n    box-shadow: 0 0 0 var(--border-width-thin) var(--dropdown-border-color-hover);\n  }\n\n  :focus {\n    outline: var(--border-width-thin) solid var(--dropdown-border-color-focus);\n  }\n\n  //disabled sobrescreve os outros styles\n  :disabled {\n    background-color: var(--dropdown-background-color-disabled);\n    color: var(--dropdown-color-font-disabled);\n    cursor: not-allowed;\n    box-shadow: 0 0 0 var(--border-width-hairline) var(--dropdown-border-color-disabled);\n  }\n"])), _ref7 => {
  let {
    variant
  } = _ref7;
  return variant === 'medium' ? "\n        font-size: var(--font-size-xs);\n        padding: var(--spacing-1-5) var(--spacing-2);\n        padding-right: var(--spacing-6);\n        border-radius: var(--border-radius-sm);\n      " : "\n        font-size: var(--font-size-xxs);\n        padding: var(--spacing-0-5) var(--spacing-1);\n        padding-right: var(--spacing-4);\n        border-radius: var(--border-radius-xs);\n      ";
}, _ref8 => {
  let {
    variant,
    iconLeft
  } = _ref8;
  return variant === 'medium' && iconLeft && "padding-left: calc(var(--spacing-1) * 2 + ".concat(LEFT_ICON_SIZES.medium, ");");
}, _ref9 => {
  let {
    variant,
    iconLeft
  } = _ref9;
  return variant !== 'medium' && iconLeft && "padding-left: calc(var(--spacing-1) * 2 + ".concat(LEFT_ICON_SIZES.small, ");");
}, selectedStyle, errorStyle);
export const IconWrapper = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  ", "\n  ", "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n\n  svg {\n    fill: ", ";\n    width: 100%;\n    height: 100%;\n  }\n"])), _ref10 => {
  let {
    variant
  } = _ref10;
  return variant && "\n    width: ".concat(LEFT_ICON_SIZES[variant], ";\n    height: ").concat(LEFT_ICON_SIZES[variant], ";\n    min-width: ").concat(LEFT_ICON_SIZES[variant], ";\n    min-height: ").concat(LEFT_ICON_SIZES[variant], ";\n    max-width: ").concat(LEFT_ICON_SIZES[variant], ";\n    max-height: ").concat(LEFT_ICON_SIZES[variant], ";\n  ");
}, _ref11 => {
  let {
    variant
  } = _ref11;
  return variant === 'medium' ? "left: 12px; top: 12px;" : "left: 8px; top: 6px;";
}, _ref12 => {
  let {
    selected
  } = _ref12;
  return selected ? 'var(--dropdown-color-font-selected)' : 'var(--dropdown-color-font-base)';
}, _ref13 => {
  let {
    selected
  } = _ref13;
  return selected ? 'var(--dropdown-color-font-selected)' : 'var(--dropdown-color-font-base)';
});